import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  Train: {
    first_name: '',
    last_name: '',
    stationname_from: '',
    stationname_to: '',
    train_travel_date: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
